export default __webpack_public_path__ + "/dist/images/buyer-ai-card-optimized.322f5edd7942f508f97c600f2de74fc1.jpg";